/** The folded rail's tab; a page starts on it to open there whenever the rail folds, falling back to its first tab otherwise. */
export const DETAILS_TAB = '__details__';
